<template>
  <h1 :class="$style.spotlightTitle">"{{ listingTitle }}"</h1>
</template>

<script lang="ts" setup>
import { getListingDefaultLocale } from '@/helpers/ListingData/ListingData';
import { L10N, Listing } from '@smg-real-estate/hg-rets-schema';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineOptions({
  name: 'ListingTitle',
});

interface Props {
  listing: Listing;
}
const props = defineProps<Props>();

const listingDefaultLocale = computed<L10N | undefined>(() =>
  getListingDefaultLocale(props.listing),
);
const listingTitle = computed<string | undefined>(() => {
  const defaultTitle = listingDefaultLocale.value?.text?.title;
  const offerType = props.listing.offerType?.toLowerCase();
  const offerTypeTranslated = offerType ? String(t(`breadCrumbs.offerType.${offerType}`)) : '';
  const category = props.listing?.categories?.slice(-1)[0];
  const categoryTranslated = category ? String(t(`listingCategories.${category}`)) : '';
  return defaultTitle || `${offerTypeTranslated} ${categoryTranslated}`;
});
</script>

<style lang="scss" module>
@import '@/assets/variables';

.spotlightTitle {
  @include heading-3($color-grey-120);

  width: 100%;
  margin: 0;
}
</style>
